// import React, { useState, useRef } from 'react';
import ContactForm from './ContactForm';

function ModalAbout({ isOpen, onClose }) {

  // Check if isOpen is false, and if so, return null immediately
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <div className="Contact-form">
          <h1 style={{ margin: '0 auto' }}>Æthel Music</h1>
          <p>Æthel's artist name symbolizes having a warrior queen spirit in the face of your darkest times while also embodying fantasy romanticism and beauty.
            She creates siren pop acoustic ballads from her home studio and has two self-produced EP's coming out over this year. Æthel is a lyrical storyteller and writes custom songs. She recently placed her home produced ethereal ballad "Fog and Fire" as the theme song for a podcast about mental health, "Out of the Fog", helping women recover from postnatal depression with great success.
            Her emotive lyrical and ethereal production has often moved people to tears and inspired other female artists as she expresses thoughts and emotions about heartbreak, love, maternity, betrayal, failure and courage.
            Her roots are in folk and CCM but she has grown her own alternative pop sound using vocality in unique ways layered in her soundscapes. </p>
          <h3>CONTACT</h3>
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default ModalAbout;




